export const WS_CMS_EMIT = 'ws/CMS_EMIT';
export const WS_INIT = 'ws/INIT';
export const GET_DESKTOP_STATUS = 'ws/GET_DESKTOP_STATUS';
export const RECEIVE_DESKTOP_STATUS = 'ws/RECEIVE_DESKTOP_STATUS';
export const SCREEN_IS_UPDATED = 'ws/SCREEN_IS_UPDATED';

export const wsSubscribe = [RECEIVE_DESKTOP_STATUS];
